import request from "@/axios.js";
import moment, { lang } from "moment";

export default class ProspectSearch {
	/**
	 * ProspectSearch class
	 * @property {Number} id - ProspectSearch id.
	 * @property {String} name - Name of the ProspectSearch.
	 * @property {Date} creation_date - Creation date of the ProspectSearch.
	 * @property {String} domain_activity - ProspectSearch's domain of activity.
	 * @property {Number} status - Status of the ProspectSearch.
	 * @property {Number} user_id - User id of the creator of the ProspectSearch.
	 * @property {Array} keyword_list - List of keyword separated by colon associated to the ProspectSearch.
	 * @property {Array} prospect_list - List of prospect objects associated with the ProspectSearch.
	 * @property {Array} serp_list - List of SERP objects linked to the ProspectSearch based on prospects and keywords.
	 */
	constructor(ps) {
		this.id = ps.id || null;
		this.name = ps.name || null;
		this.creation_date = ps.creation_date || moment().format("YYYY-MM-DD")+ " 02:00:00";
		this.domain_activity = ps.domain_activity || null;
		this.status = ps.status || 0;
		this.user_id = ps.user_id || null;
		this.location_id = ps.location_id || 32;
		this.language_id = ps.language_id || 1;
		this.language_name = ps.language_name || "French";
		this.search_engine_id= ps.search_engine_id || 1;
		this.keyword_list = ps.keyword_list || null;
		this.prospect_list = ps.prospect_list || [];
		this.serp_list = ps.serp_list || [];
		this.autoRun = ps.autoRun || false;
		this.type = ps.type || 1;
	}

	static getFormFields() {
		let today = new Date(Date.now());
		let todayString = today.toISOString();
		todayString = todayString.substring(0, 10);
		todayString = todayString + " 02:00:00";

		return {
			id: null,
			name: null,
			creation_date:moment().format("YYYY-MM-DD")+ " 02:00:00",
			domain_activity: null,
			status: 0,
			user_id: null,
			location_id: 72,
			language_id: 32,
			search_engine_id: 1,
			keyword_list: null,
			prospect_list: [],
			serp_list: [],
			autoRun: true,
			location_code: 2250,
			language_code: "fr",
			type: 1,
			language_name: "French",
			choosenKeywords: [],
			isLoadingLastStep: true,
		};
	}

	checkRequiredParams(){
		let paramsOk = true;
		paramsOk = this.name ? true : false;
		// paramsOk = this.creation_date ? true : false
		paramsOk = this.domain_activity ? true : false;
		paramsOk = this.user_id ? true : false;
		return paramsOk;
	}

	/**
	 *
	 * @param {Function} [callback]
	 */
	createProject(){
			return new Promise((resolve, reject) => {
				request.post("/prospect/newProject", this)
					.then(res => {
						resolve(res.data);
					}
				)
					.catch(err => {
						reject(err);
					}
					);
			});
		// }
		// else{
		// 	callback("Required parameters not set.", null);
		// }
	}
	createSimpleProject(){
		return new Promise((resolve, reject) => {
			request.post("/prospect/newSimpleProject", this)
				.then(res => {
					resolve(res.data);
				}
			)
				.catch(err => {
					reject(err);
				}
				);
		});
		// }
		// else{
		// 	callback("Required parameters not set.", null);
		// }
	}
	/**
	 *
	 * @param {Function} [callback]
	 */
	editProject(id, callback){
		// if(this.checkRequiredParams){
		request.post("/prospect/project/edit/" + id, this)
			.then(res => {
				callback(null, res.data);
			})
			.catch(err => {
				callback(err, null);
			});
		// }
		// else{
		// 	callback("Required parameters not set.", null);
		// }
	}
	/**
	 * Update Project
	 * @param {*} id 
	 * @returns 
	 */
	updateProject(id){
		return new Promise((resolve, reject) => {
			request.post("/prospect/project/update", this)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	/**
	 * 
	 * @param {Number} id - project_id 
	 * @returns 
	 */
	static async getKeywordsByProjectId(id){
		return new Promise((resolve, reject) => {
			request.get("/prospect/project/keywords/"+id)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
		
	static async getProspectsByProjectId(id){
		return new Promise((resolve, reject) => {
			request.get("/prospect/project/prospects/"+id)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
		
	/**
	 * Delete Keywords By Project Id
	 * @param {Number} id 
	 * @returns 
	 */
	static async deleteKeywordsByProjectId(id){
		return new Promise((resolve, reject) => {
			request.delete("/prospect/keywordsByProjectid?projectId=" + id)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
			});
	}
	/**
	 * Delete Prospect By Project Id
	 * @param {Number} id 
	 * @returns 
	 */
	static async deleteProspectByProjectId(id){
		return new Promise((resolve, reject) => {
			request.delete("/prospect/prospectByProjectid?projectId=" + id)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
			});
	}
	/**
	 * GET Prospect Project Details
	 * @param {Int} pid - project_id
	 */
	static fetchProspectProjectDetails(pid){
		return new Promise((resolve, reject) => {
			request.get("/prospect/getProjectDetail/" + pid)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		}	);

	}
	/**
	 * GET Prospect By Project Details
	 * @param {Int} pid - project_id
	 */
	static getProspectByProjectId(pid){
		return new Promise((resolve, reject) => {
			request.get(
				`/prospect/getByProjectId?id=${pid}&limit=1000&page=0`
			)
				.then(res => {
					resolve(res.data.dataList);
				})
				.catch(err => {
					reject(err);
				});
		}	);

	}
	/**
	 * GET Prospect Technologies
	 *  @param {Int} pid - project_id
	 */
	static getProspectTechnologies(pid){
		return new Promise((resolve, reject) => {
			request.get(
				`/prospect/getDomainTecnologies?id=${pid}`
			)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		}	);

	}
		/**
	 * GET Prospect Technologies
	 *  @param {Int} pid - project_id
	 */
		static getProspectEmployees(pid){
			return new Promise((resolve, reject) => {
				request.get(
					`/prospect/linkedinInfo?prospectId=${pid}`
				)
					.then(res => {
						resolve(res.data);
					})
					.catch(err => {
						reject(err);
					});
			}	);
	
		}
				/**
	 * Update a prospect's LinkedIn URL
	 * @param {Number} prospectId - prospect id
	 * @param {String} linkedinUrl - LinkedIn company URL
	 */
				static updateLinkedinUrl(prospectId, linkedinUrl){
					return new Promise((resolve, reject) => {
						request.put(
							`/prospect/linkedinUrl`,
							{
								"prospectId": prospectId,
								"linkedinUrl": linkedinUrl
							}
						)
							.then(res => {
								resolve(res.data);
							})
							.catch(err => {
								reject(err);
							});
					}	);

				}
				/**
	 * Add Prospect Lead
	 *  @param {String} linkedinUrl
	 * @param {String} campaignId
	 * @param {String} employeeId
	 */
				static launchCampaignForOneLead(linkedinUrl, campaignId, employeeId, prospectId, sentUserId){
					return new Promise((resolve, reject) => {
						request.post(
							`/lemlist/prospect/campaign/launchForOneLead`,
							{
								"linkedinUrl": linkedinUrl,
								"campaignId": campaignId,
								"employeeId": employeeId,
								"prospectId": prospectId,
								"sentUserId": sentUserId
							}
						)
							.then(res => {
								resolve(res.data);
							})
							.catch(err => {
								reject(err);
							});
					}	);
			
				}
				
				static getLeadActivitesByProspectId(prospectId){
					return new Promise((resolve, reject) => {
						request.get(
							`/lemlist/prospect/activitesByProspectId?prospectId=${prospectId}`,
						)
							.then(res => {
								resolve(res.data);
							})
							.catch(err => {
								reject(err);
							});
					}	);
			
				}
	/**
	 * Get Counties List
	 * @param {*} callback 
	 */
	static getCountryList(callback){
		request.get("/countries/all")
			.then(res => {
				callback(null, res.data);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	/**
	 * Get Search engines List with its languages
	 * @param {*} callback 
	 */
	static getSearchEngines(callback){
		request.get("/others/search_engines")
			.then(res => {
				callback(null, res.data);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	/**
	 * Get Search engines List with its languages
	 * @param {Integer} id - Search engine Id 
	 * @param {*} callback 
	 */
	static getSearchEnginesLanguages(id, callback){
		request.get("/others/search_engines_languages?search_engine_id="+id)
			.then(res => {
				callback(null, res.data);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	/**
	 * Get Search engines List with its Countries
	 * @param {Integer} id - Search engine Id 
	 * @param {*} callback 
	 */
	static getSearchEnginesCountryList(id, callback){
		request.get("/others/search_engines_countries?search_engine_id="+id)
			.then(res => {
				callback(null, res.data);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	static getRadarData(id){
		return new Promise((resolve, reject) => {
		request.get("/prospect/radarData?prospectId=" + id)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
		});
	}
	/**
	 * Fetch keywords Ideas
	 * @param {Object} body 
	 * @returns 
	 */
	static getKeywordsIdeas(body){
		return new Promise((resolve, reject) => {
		request.post("/dataforseo/getKeywordsIdeas/", body)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err);
			});
		});
	}

	/*
	 *   update(callback){
	 *     if(this.purchase_date && this.renew_date){
	 *       request.post("/dns/edit", this)
	 *         .then(res => {
	 *           callback(null, res)
	 *         })
	 *         .catch(err => {
	 *           callback(err, null)
	 *         })
	 *     }else{
	 *       callback("Date not set.", null)
	 *     }
	 *   }
	 */

	/**
	 * Load ProspectSearch info from id
	 * @param {Number} ps_id Id of the ProspectSearch to load
	 * @param {Function} [callback]
	 */
	loadFromId(ps_id=null, full=false, callback){
		let id = null;
		if(ps_id) id = ps_id;
		else if(this.id) id = this.id;
		else{
			callback("Id required.", null);
		}
		let query = "/ps/get/";
		if(full == true) query = "/ps/getfull/";
		request.get(query + id)
			.then(res => {
				if(res.length > 0){
					this.id = res[0].id,
					this.name = res[0].name,
					this.creation_date = res[0].creation_date,
					this.domain_activity = res[0].domain_activity,
					this.status = res[0].status,
					this.user_id = res[0].user_id;
					if(full == true){
						this.keyword_list = res[0].keyword_list;
						this.prospect_list = res[0].prospect_list;
						this.serp_list = res[0].serp_list;
					}
				}
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	/**
	 * Update ProspectSearch keywords
	 * @param {String} keywords
	 * @param {Function} [callback]
	 */
	updateKeywords(keywords, callback){
		let params = {
			ps_id: this.id,
			keywords: keywords
		};
		request.post("/ps/addkeywords", params)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	static async updateKeywords(keywords){
		return new Promise((resolve, reject) => {
			request.put("/prospect/keywords", keywords)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async updateProspectUrls(prospectUrls){
		return new Promise((resolve, reject) => {
			request.put("/prospect/urls/", prospectUrls)
				.then(res => {
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getOpenAiKeywordsIdeas(body){
		return new Promise((resolve, reject) => {
			request.post("/prospect/getKeywordsIdeas/openai", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getOpenAiKeywordsIdeasByUrl(body){
		return new Promise((resolve, reject) => {
			request.post("/prospect/getKeywordsIdeasByUrl/openai", body)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	/**
	 * Update ProspectSearch prospects
	 * TODO: Manage auto link/unlink based on given list in back
	 * @param {Array} prospects
	 * @param {Function} [callback]
	 */
	updateProspects(prospects, callback){
		let params = {
			ps_id: this.id,
			prospects: prospects
		};
		request.post("/ps/addprospects", params)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	/**
	 * Returns in callback an array of ProspectsSearches objects with only basics info
	 * @param {Function} [callback]
	 */
	static getAllProspectsSearches(callback){
		request.get("/ps/all")
			.then(res => {
				let allProspectsSearches = [];
				for(let row of res){
					let prospectsSearchesObject = new ProspectSearch(row);
					allProspectsSearches.push(prospectsSearchesObject);
				}
				callback(null, allProspectsSearches);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	/**
	 * Returns in callback an array of ProspectsSearches objects with all info including prospects' list, keywords' list and serps' data
	 * @param {Function} [callback]
	 */
	static getAllProspectsSearchesFull(callback){
		request.get("/ps/allfull")
			.then(res => {
				let allProspectsSearches = [];
				for(let row of res){
					let prospectsSearchesObject = new ProspectSearch(row);
					allProspectsSearches.push(prospectsSearchesObject);
				}
				callback(null, allProspectsSearches);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	/*
	 * static getNetlinksForPurchase(purchaseId, callback){
	 *   request.get("/dns/getp/" + purchaseId)
	 *     .then(res => {
	 *       callback(null, res)
	 *     })
	 *     .catch(err => {
	 *       callback(err, null)
	 *     })
	 * }
	 */

	/*
	 * static getNetlinksForRecurringPurchase(recurringPurchaseId, callback){
	 *   request.get("/dns/getrp/" + recurringPurchaseId)
	 *     .then(res => {
	 *       callback(null, res)
	 *     })= '
	 *     .catch(err => {
	 *       callback(err, null)
	 *     })
	 * }
	 */

	/**
	 * Change the status of the ProspectSearch to archive (1)
	 * @param {Number} psId Id of the ProspectSearch to archive
	 * @param {Function} [callback]
	 */
	static archive(psId, callback){
		request.get("/prospect/project/archive/" + psId)
			.then(res => {
				callback(null, res);
			})
			.catch(err => {
				callback(err, null);
			});
	}
	static async getRankwellDataStatus(){
		return new Promise((resolve, reject) => {
			request.get("/prospect/check/workLoad/")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getRankwellDataStatus(){
		return new Promise((resolve, reject) => {
			request.get("/prospect/check/workLoad/")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getLemlistCampaignList(){
		return new Promise((resolve, reject) => {
			request.get("/lemlist/campaigns")
				.then(res => {
					resolve(res.data.campaigns);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getLemlistCampaignListBySender(senderemail){
		return new Promise((resolve, reject) => {
			request.get("/lemlist/campaigns")
				.then(res => {
					resolve(res.data.campaigns);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getAllProccessLeads(){
		return new Promise((resolve, reject) => {
			request.get("/lemlist/prospect/getAllProcessedLeads")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getStatus(){
		return new Promise((resolve, reject) => {
			request.get("/lemlist/status")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	static async getPrompts(){
		return new Promise((resolve, reject) => {
			request.get("/prospect/getPrompts/openai")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	

/*
 *   static delete(psId, callback){
 *     request.get("/ps/delete/" + psId)
 *       .then(res => {
 *         callback(null, res)
 *       })
 *       .catch(err => {
 *         callback(err, null)
 *       })
 *   }
 */
}
